import type { SVGProps } from 'react';

const SvgArrowRightUpBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M17.957 6L5.95703 18M17.957 6V15M17.957 6H8.95703'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
    />
  </svg>
);
export default SvgArrowRightUpBd;
